<template>
  <div class="inner">
      <h2 class="fz-20 d-flex border-bottom mt-0">{{ $t('標準工程') }}</h2>
      <div
        class="mt-5"
        id="baseProcessDrawing-parent">
          <div class="card">
            <div class="accordion card-header d-flex justify-content-between" id="baseProcessDrawing-header" data-toggle="collapse" data-target="#baseProcessDrawing" :aria-expanded="false" aria-controls="baseProcessDrawing">
              <h3 class="mb-0">{{ $t('標準工程') }}</h3>
              <div class="accordion-toggle-btn">
                <b-button block id="baseProcessDrawing-up">{{ $t('閉じる') }}</b-button>
                <b-button block id="baseProcessDrawing-down">{{ $t('開く') }}</b-button>
              </div>
            </div>
            <div id="baseProcessDrawing" class="collapse" aria-labelledby="baseProcessDrawing-header" data-parent="#baseProcessDrawing-parent">
              <div class="card-body">
                <template v-for="(item, index) in baseProcesses">
                  <base-process-drawing-table-in-house
                  v-if="!item.isOutSource"
                  :key="index"
                  :processes="processes"
                  :processKinds="processKinds"
                  :baseProcess="item"
                  :users="users"
                  :products="products"
                  :structures="structures"
                  ref="baseProcessTable"
                  @addStructureCost="addStructureCost()"
                  @addInHouseCost="addInHouseCost()"
                  ></base-process-drawing-table-in-house>
                  <base-process-drawing-table-outsourcing
                  v-else
                  :key="index"
                  :processKinds="processKinds"
                  :baseProcess="item"
                  :structures="structures"
                  ref="baseProcessTable"
                  @addStructureCost="addStructureCost()"
                  ></base-process-drawing-table-outsourcing>

                </template>
                <table class="table table-bordered w-30 ml-auto">
                  <tbody class="tbody">
                    <tr>
                      <th class="table-active w-50">{{ $t('製造原価') }}</th>
                      <td class="w-50">{{ InHouseCost | mixinCommaDisplay }}&nbsp;{{ $t('円') }}</td>
                    </tr>
                    <tr>
                      <th class="table-active w-50">{{ $t('構成部品原価') }}</th>
                      <td class="w-50">{{ structureCost | mixinCommaDisplay }}&nbsp;{{ $t('円') }}</td>
                    </tr>
                    <tr>
                      <th class="table-active w-50">{{ $t('合計') }}</th>
                      <td class="w-50">{{ totalCost | mixinCommaDisplay }}&nbsp;{{ $t('円') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
      </div>
      <div class="d-flex justify-content-between mt-3 mb-5">
          <button
            type="button"
            class="btn btn-light create-btn"
            @click="modalOpen()"
          >
            {{ $t('編集') }}
          </button>
      </div>
      <base-process-modal
      :processes="processes"
      :processKinds="processKinds"
      :structures="structures"
      :users="users"
      :products="products"
      :productId="productId"
      :contacts="contacts"
      :isArrangeMaterial="isArrangeMaterial"
      ref="baseProcess"
      @modalClose="modalClose()"
      @registered="registered()"
      ></base-process-modal>
  </div>
</template>

<script>
import baseProcessDrawingTableInHouse from './baseProcessDrawingTableInHouse'
import baseProcessDrawingTableOutsourcing from './baseProcessDrawingTableOutsourcing'
import baseProcessModal from './baseProcessModal'
export default {
  props: {
    baseProcesses: {
      type: Array,
      default: () => [],
    },
    processes: {
      type: Array,
      default: () => [],
    },
    processKinds: {
      type: Array,
      default: () => [],
    },
    structures: {
      type: Object,
      default: () => {},
    },
    users: {
      type: Array,
      default: () => [],
    },
    contacts: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
    productId: {
      type: Number,
      default: 0,
    },
    isArrangeMaterial: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    baseProcessModal,
    baseProcessDrawingTableInHouse,
    baseProcessDrawingTableOutsourcing,
  },
  data() {
    return {
      structureCost: 0,
      InHouseCost: 0,
      // test: [
      //   {
      //     'id': 2,
      //     'isOutSource': false,
      //     'processKindId': 12,
      //     'sort': 1,
      //     'processId': 1,
      //     'partnerId': -1,
      //     'destId': -1,
      //     'timeUnit': 'min',
      //     'prepareTime': 89,
      //     'machiningTime': 21,
      //     'orderCode': '',
      //     'purchasePrice': null,
      //     'leadTime': null,
      //     'productId': null,
      //     'hourPrice': null,
      //     'userId': 5,
      //     'jig': 'treste',
      //     'tool': 'fdsfasd',
      //     'note': 'fdsafsdasfd',
      //     structures: [
      //       {id: 44,productId: 75,quantity: 2,purchasePrice: 130,},
      //       {id: 45,productId: 63,quantity: 1,purchasePrice: 130,},
      //     ],
      //   },
      //   {
      //     'id': 3,
      //     'isOutSource': true,
      //     'processKindId': 4,
      //     'sort': 2,
      //     'processId': -1,
      //     'partnerId': 41,
      //     'destId': 10,
      //     'timeUnit': '',
      //     'prepareTime': null,
      //     'machiningTime': null,
      //     'orderCode': 'test',
      //     'purchasePrice': 21,
      //     'leadTime': 12,
      //     'productId': null,
      //     'hourPrice': null,
      //     'userId': null,
      //     'jig': '',
      //     'tool': '',
      //     'note': 'vvvvzxvc',
      //     structures: [
      //       {id:24,productId: 66,quantity: 1,purchasePrice: 120,},
      //       {id:17,productId: 47,quantity: 3,purchasePrice: 130,},
      //       {id:35,productId: 49,quantity: 5,purchasePrice: 130,},
      //     ],
      //   },
      //   {
      //     'id': 4,
      //     'isOutSource': true,
      //     'processKindId': 34,
      //     'sort': 3,
      //     'processId': -1,
      //     'partnerId': 41,
      //     'destId': null,
      //     'timeUnit': '',
      //     'prepareTime': null,
      //     'machiningTime': null,
      //     'orderCode': 'test',
      //     'purchasePrice': 21,
      //     'leadTime': 101,
      //     'productId': null,
      //     'hourPrice': null,
      //     'userId': null,
      //     'jig': '',
      //     'tool': '',
      //     'note': 'vvvvzxvc',
      //     structures: [],
      //   },
      // ],
    }
  },
  mounted() {
    const up = document.getElementById('baseProcessDrawing-up')
    const down = document.getElementById('baseProcessDrawing-down')
    up.classList.add('is-hide')
    down.classList.add('is-show')
    $('#baseProcessDrawing').on('show.bs.collapse', function() {
      const up = document.getElementById('baseProcessDrawing-up')
      const down = document.getElementById('baseProcessDrawing-down')
      up.classList.add('is-show')
      up.classList.remove('is-hide')
      down.classList.remove('is-show')
      down.classList.add('is-hide')
    })
    $('#baseProcessDrawing').on('hide.bs.collapse', function() {
      const up = document.getElementById('baseProcessDrawing-up')
      const down = document.getElementById('baseProcessDrawing-down')
      up.classList.remove('is-show')
      up.classList.add('is-hide')
      down.classList.add('is-show')
      down.classList.remove('is-hide')
    })
  },
  methods: {
    modalOpen() {
      this.$refs.baseProcess.modalOpen(this.baseProcesses)
    },
    modalClose() {
      this.$emit('modalClose')
    },
    registered() {
      this.$emit('registered')
    },
    addStructureCost() {
      this.structureCost = 0
      for (let i = 0; i < this.baseProcesses.length; i++) {
        this.$refs.baseProcessTable[i].addStructureCost()
      }
    },
    addInHouseCost() {
      this.InHouseCost = 0
      for (let i = 0; i < this.baseProcesses.length; i++) {
        this.$refs.baseProcessTable[i].addInHouseCost()
      }
    },
  },
  computed: {
    totalCost() {
      this.$emit('addTotalCost', (this.InHouseCost + this.structureCost))
      return this.InHouseCost + this.structureCost
    },
  },
  watch: {
    'baseProcesses': {
      handler: function(newVal) {
        if (newVal.length === 0) {
          $('#baseProcessDrawing').collapse('hide')
        } else {
          $('#baseProcessDrawing').collapse('show')
        }
      },
      deep: true,
    },
  },
}
</script>

<style>

</style>
